/* https://www.stefanjudis.com/blog/validate-urls-in-javascript/
May be replaced by URL.canParse() in the future
https://caniuse.com/mdn-api_url_canparse_static
 */
export function isUrlValid(urlString) {
    try {
        new URL(urlString);
        return true;
    }
    catch (e) {
        console.log(e);
        return false;
    }
}
